import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import ClientsTable from "../clientsTable";
import useMediaQuery from "@mui/material/useMediaQuery";

const ClientsModal = ({ open, setOpen, setFormState, formState }) => {
  const isMobile = useMediaQuery('(max-width:600px)');
  const handleClose = () => setOpen(false);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: isMobile ? "95%" : "80%",
    maxWidth: "1200px",
    height: isMobile ? "90%" : "80%",
    maxHeight: "800px",
    display: "flex",
    justifyContent: "center",
    bgcolor: "background.paper",
    borderRadius: isMobile ? "5px" : "10px",
    overflow: "auto",
    boxShadow: 24,
    p: isMobile ? 1 : 4,
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Fade in={open}>
        <Box sx={style}>
          <Box
            sx={{
              width: "100%",
              height: "100%",
              overflow: "auto",
            }}
          >
            <ClientsTable
              setOpen={setOpen}
              setFormState={setFormState}
              formState={formState}
            />
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
};

export default ClientsModal;
